<template>
  <div class="main">
    <div class="pic">
      <!--      <div class="split">分时：</div>-->
      <div class="tab">
        <van-tabs v-model="activeName" @click="onClick">
          <van-tab
            v-for="(item, index) in tabList"
            :key="index"
            :title="item.title"
            :name="item.name"
          >
            <PrintKLine
              :minute="minute"
              v-if="minute == item.name"
            ></PrintKLine>
          </van-tab>
        </van-tabs>
      </div>
    </div>

    <div class="metal" v-if="Object.keys(kLineData).length !== 0">
      <p>* 以上行情走势仅做示意，不作为投资参考</p>
      <!--      <div-->
      <!--        class="metalSale"-->
      <!--        v-lazy:background-image="require(`../../../assets/metalSale.png`)"-->
      <!--      >-->
      <!--        <div class="saleVal">￥{{ salePrice }}</div>-->
      <!--        <div class="saleName">黄金销售</div>-->
      <!--      </div>-->
      <!--      <div-->
      <!--        class="metalRecycling"-->
      <!--        v-lazy:background-image="require(`../../../assets/metalRecycling.png`)"-->
      <!--      >-->
      <!--        <div class="recyclingVal">￥{{ recyclingPrice }}</div>-->
      <!--        <div class="recyclingName">黄金回收</div>-->
      <!--      </div>-->
    </div>
  </div>
</template>

<script>
import PrintKLine from "./printKLine";
export default {
  props: ["kLineData"],
  watch: {},
  computed: {
    salePrice() {
      return this.kLineData.salePrice.toFixed(2);
    },
    recyclingPrice() {
      return this.kLineData.recyclingPrice.toFixed(2);
    },
  },
  components: { PrintKLine },
  data() {
    return {
      activeName: "1440",
      minute: "1440",
      tabList: [
        { title: "5分", name: "5" },
        { title: "15分", name: "15" },
        { title: "30分", name: "30" },
        { title: "1小时", name: "60" },
        { title: "1天", name: "1440" },
      ],
    };
  },
  created() {
    console.log("kMain");
  },
  mounted() {
    this.onClick("1440");
  },

  methods: {
    onClick(name) {
      this.minute = name;
    },
  },
};
</script>

<style lang="less" scoped>
.main {
  width: 750px;
  height: 1036px;
  background: rgba(255, 255, 255, 1);
  border-radius: 24px 24px 0px 0px;
  position: absolute;
  top: 250px;
  .pic {
    position: relative;
    .split {
      position: absolute;
      left: 8px;
      top: 23px;
      color: rgba(102, 102, 102, 1);
      font-size: 28px;
    }
    .tab {
    }
  }
  .time {
    width: 475px;
    height: 30px;
    display: flex;
    justify-content: space-between;
    color: rgba(51, 51, 51, 1);
    font-size: 22px;
    margin-left: 31px;
    margin-top: 8px;
  }
  .metal {
    width: 686px;
    height: 136px;
    margin-left: 31px;
    margin-top: 24px;
    display: flex;
    justify-content: space-between;
    div {
      width: 334px;
      height: 136px;
    }
    .metalSale {
      background: no-repeat;
      background-size: 100%;
      .saleVal {
        width: 123px;
        height: 45px;
        line-height: 45px;
        color: rgba(248, 126, 37, 1);
        font-size: 32px;
        margin-left: 24px;
        margin-top: 25px;
      }
      .saleName {
        width: 120px;
        height: 37px;
        line-height: 37px;
        color: rgba(248, 126, 37, 1);
        font-size: 26px;
        margin-left: 24px;
      }
    }
    .metalRecycling {
      background: no-repeat;
      background-size: 100%;
      .recyclingVal {
        width: 123px;
        height: 45px;
        line-height: 45px;
        color: rgba(68, 120, 255, 1);
        font-size: 32px;
        margin-left: 187px;
        margin-top: 25px;
      }
      .recyclingName {
        width: 120px;
        height: 37px;
        line-height: 37px;
        color: rgba(68, 120, 255, 1);
        font-size: 26px;
        margin-left: 187px;
      }
    }
  }
}
::v-deep .van-tabs__nav {
  background: none;
  width: 80%;
}
::v-deep .van-tabs__line {
  width: 15px;
  bottom: 22px;
  height: 2px;
  background-color: #cfab74 !important;
}
::v-deep .van-tabs__wrap--scrollable .van-tab {
  padding: 0;
}

::v-deep .van-tab {
  color: #999999;
}

::v-deep .van-tab--active {
  color: #cfab74 !important;
}
</style>
